// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"399ca7a2","281":"1fa81c7c","765":"b90255a1","823":"aeb0696c"}[chunkId] + ".chunk.js";
};